var plugin_rtlignore_default = {
  "alignLeft": "bgWFi",
  "textWrapNowrap": "Gt6bV",
  "alignRight": "A6N9h",
  "alignCenter": "_2xhRh",
  "sizeFullWidth": "bD9ii",
  "renderedInTable": "NCsXp",
  "sizeOriginal": "UDpeK",
  "sizeContent": "SzlJi",
  "sizeSmall": "Y908q",
  "sizeSmallCenter": "MEFMo",
  "flex": "BN4uD",
  "atomic": "_29Yle",
  "embed": "VABKV",
  "horizontalScrollbar": "X9HPD",
  "pluginContainerMobile": "MME-g"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
